
import { SaleDetails } from "@/types/sales";

/**
 * Calculate the correct total premium for a policy,
 * ensuring endorsement premiums are not double-counted
 */
export const calculatePolicyTotal = (policies: SaleDetails[]) => {
  if (!policies || policies.length === 0) return 0;
  
  return policies.reduce((sum, policy) => {
    // For policies with both base premium and endorsement premium,
    // we only want to count the base premium since it already includes
    // the effect of endorsements
    const premium = Number(policy.premium_amount) || 0;
    
    // Only add endorsement_premium if we're specifically tracking a separate
    // endorsement transaction, not for regular policy premiums that already
    // include endorsement effects
    return sum + premium;
  }, 0);
};
